import React from 'react';

interface WorkflowStep {
  name: string;
  icon?: string;
}

interface WorkflowSidebarProps {
  steps: WorkflowStep[];
  currentStep: number;
  completedSteps: number[];
  onStepClick: (step: number) => void;
}

const WorkflowSidebar: React.FC<WorkflowSidebarProps> = ({
  steps,
  currentStep,
  completedSteps,
  onStepClick,
}) => {
  return (
    <div
      style={{
        width: 200,
        minWidth: 200,
        background: 'var(--hover-bg)',
        borderRight: '1px solid var(--card-border)',
        padding: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {steps.map((step, i) => {
        const isActive = i === currentStep;
        const isCompleted = completedSteps.includes(i);

        return (
          <button
            key={i}
            onClick={() => onStepClick(i)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '10px 16px',
              background: isActive ? 'rgba(245, 158, 11, 0.1)' : 'transparent',
              border: 'none',
              borderLeft: isActive ? '3px solid #f59e0b' : '3px solid transparent',
              cursor: 'pointer',
              color: isActive ? '#f59e0b' : isCompleted ? '#34d399' : 'var(--text-muted)',
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              textAlign: 'left',
              transition: 'all 150ms ease',
              width: '100%',
            }}
          >
            <span
              style={{
                width: 22,
                height: 22,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 11,
                fontWeight: 700,
                background: isCompleted
                  ? '#34d399'
                  : isActive
                  ? '#f59e0b'
                  : 'var(--card-border)',
                color: isCompleted || isActive ? 'var(--content-bg)' : 'var(--text-muted)',
                flexShrink: 0,
              }}
            >
              {isCompleted ? (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2.5 6L5 8.5L9.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                i + 1
              )}
            </span>
            {step.name}
          </button>
        );
      })}
    </div>
  );
};

export default WorkflowSidebar;
